export const cpublica= [
    /* {
        "anio" : "2025",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de variación en la hacienda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de cambios en la situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de flujos de efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de la deuda y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de pasivos contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los estados financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los ingresos presupuestarios y contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de analítico de ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación económica de los ingresos, de los gastos y del financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación económica (por tipo de gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de postura fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por categoría programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y proyectos de inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de bienes muebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de bienes inmuebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de cuentas bancarias productivas específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de esquemas bursátiles y de coberturas financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del ejercicio y destino de gasto federalizado y reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, asignaciones, subsidios y subvenciones, y pensiones y jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (del grupo hacienda pública/patrimonio contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de situación financiera detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de la deuda pública y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de obligaciones diferentes de financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de Cumplimiento de la Ley de Disciplina Financiera de las Entidades Federativas y los Municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance presupuestario de recursos disponibles negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el año que integra el pasivo circulante al cierre del ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos excedentes derivados de ingresos de libre disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de deuda pública y obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información detallada de contratación de obligaciones a corto plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "comparativo del estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe ejecutivo (comparativos situación financiera y ejercicio del presupuesto de egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos presupuestales por rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la situación económica de las finanzas públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la deuda pública variación respecto a la deuda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 1 erogaciones para la ciencia y tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 2 derechos humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 3 transparencia y rendición de cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 4 anexo transversal anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 5 indicadores de desempeño (estratégicos y de gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados (avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, proyectos, obras o acciones con aportaciones de recursos por parte del gobierno del estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los programas de reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y remuneraciones cubiertas a los servidores público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos (etiquetado y no etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por prestación de servicios profesionales por honorarios (personas físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2025/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },*/
    {
        "anio" : "2024",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de variación en la hacienda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de cambios en la situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de flujos de efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de la deuda y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de pasivos contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los estados financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los ingresos presupuestarios y contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de analítico de ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación económica de los ingresos, de los gastos y del financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación económica (por tipo de gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de postura fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por categoría programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y proyectos de inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de bienes muebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de bienes inmuebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de cuentas bancarias productivas específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de esquemas bursátiles y de coberturas financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del ejercicio y destino de gasto federalizado y reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, asignaciones, subsidios y subvenciones, y pensiones y jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (del grupo hacienda pública/patrimonio contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de situación financiera detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de la deuda pública y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de obligaciones diferentes de financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de Cumplimiento de la Ley de Disciplina Financiera de las Entidades Federativas y los Municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance presupuestario de recursos disponibles negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el año que integra el pasivo circulante al cierre del ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos excedentes derivados de ingresos de libre disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de deuda pública y obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información detallada de contratación de obligaciones a corto plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "comparativo del estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe ejecutivo (comparativos situación financiera y ejercicio del presupuesto de egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos presupuestales por rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la situación económica de las finanzas públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la deuda pública variación respecto a la deuda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 1 erogaciones para la ciencia y tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 2 derechos humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 3 transparencia y rendición de cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 4 anexo transversal anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 5 indicadores de desempeño (estratégicos y de gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados (avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, proyectos, obras o acciones con aportaciones de recursos por parte del gobierno del estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los programas de reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y remuneraciones cubiertas a los servidores público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos (etiquetado y no etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por prestación de servicios profesionales por honorarios (personas físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2024/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },
    {
        "anio" : "2023",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de variación en la hacienda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de cambios en la situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de flujos de efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de la deuda y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de pasivos contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los estados financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los ingresos presupuestarios y contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de analitico de ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación económica de los ingresos, de los gastos y del financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos elasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación económica (por tipo de gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de postura fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por categoría programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y proyectos de inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de bienes muebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de bienes inmuebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de cuentas bancarias productivas específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de esquemas bursátiles y de coberturas financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del ejercicio y destino de gasto federalizado y reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, asignaciones, subsidios y subvenciones, y pensiones y jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (del grupo hacienda pública/patrimonio contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de situación financiera detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de la deuda pública y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de obligaciones diferentes de financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance presupuestario",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación de servicios personales por categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "guía de cumplimiento de la ley de disciplina financiera de las entidades federativas y los municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance presupuestario de recursos disponibles negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el año que integra el pasivo circulante al cierre del ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos excedentes derivados de ingresos de libre disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de deuda pública y obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información detallada de contratación de obligaciones a corto plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Comparativo del estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe ejecutivo (comparativos situación financiera y ejercicio del presupuesto de egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos presupuestales por rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la situación económica de las finanzas públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la deuda pública variación respecto a la deuda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 1 Erogaciones para la Ciencia y Tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 2 Derechos Humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 3 Transparencia y Rendición de Cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 4 Anexo Transversal Anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño ( Estrategia Transversal 5 Indicadores de Desempeño (Estratégicos y de Gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados (Avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, Proyectos, Obras o Acciones con Aportaciones de Recursos por parte del Gobierno del Estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los Programas de Reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y Remuneraciones Cubiertas a los Servidores Público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o Creación del Gasto del Presupuesto de Egresos (Etiquetado y No Etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por Prestación de Servicios Profesionales por Honorarios (Personas Físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2023/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },
    {
        "anio" : "2022",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de Variación en la Hacienda Pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de Cambios en la Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de Flujos de Efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de la Deuda y Otros Pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de Pasivos Contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los Estados Financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los Ingresos Presupuestarios y Contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Analitico de ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación Económica de los Ingresos, de los Gastos y del Financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento Neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la Deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Postura Fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por Categoría Programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y Proyectos de Inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de Bienes Muebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de Bienes Inmuebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de Cuentas Bancarias Productivas Específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de Esquemas Bursátiles y de Coberturas Financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del Ejercicio y Destino de Gasto Federalizado y Reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, Asignaciones, Subsidios y Subvenciones, y Pensiones y Jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (Del grupo Hacienda Pública/Patrimonio Contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Situación Financiera Detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe Analítico de la Deuda Pública y Otros Pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe Analítico de Obligaciones Diferentes de Financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance Presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de Ingresos Detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de Cumplimiento de la Ley de Disciplina Financiera de las Entidades Federativas y los Municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance Presupuestario de Recursos Disponibles Negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o Creación del Gasto del Presupuesto de Egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el Año que Integra el Pasivo Circulante al Cierre del Ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos Excedentes Derivados de Ingresos de Libre Disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de Deuda Pública y Obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información Detallada de Contratación de Obligaciones a Corto Plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Comparativo del Estado de Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe Ejecutivo (Comparativos Situación Financiera y Ejercicio del Presupuesto de Egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de Ingresos Presupuestales por Rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la Situación Económica de las Finanzas Públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la Deuda Pública Variación respecto a la Deuda Pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 1 Erogaciones para la Ciencia y Tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 2 Derechos Humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 3 Transparencia y Rendición de Cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 4 Anexo Transversal Anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño ( Estrategia Transversal 5 Indicadores de Desempeño (Estratégicos y de Gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados (Avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, Proyectos, Obras o Acciones con Aportaciones de Recursos por parte del Gobierno del Estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los Programas de Reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y Remuneraciones Cubiertas a los Servidores Público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o Creación del Gasto del Presupuesto de Egresos (Etiquetado y No Etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por Prestación de Servicios Profesionales por Honorarios (Personas Físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2022/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },
    {
        "anio" : "2021",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de Variación en la Hacienda Pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de Cambios en la Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de Flujos de Efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de la Deuda y Otros Pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de Pasivos Contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los Estados Financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los Ingresos Presupuestarios y Contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Analitico de Ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación Económica de los Ingresos, de los Gastos y del Financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento Neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la Deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Postura Fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por Categoría Programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y Proyectos de Inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de Bienes Muebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de Bienes Inmuebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de Cuentas Bancarias Productivas Específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de Esquemas Bursátiles y de Coberturas Financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del Ejercicio y Destino de Gasto Federalizado y Reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, Asignaciones, Subsidios y Subvenciones, y Pensiones y Jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (Del grupo Hacienda Pública/Patrimonio Contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Situación Financiera Detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe Analítico de la Deuda Pública y Otros Pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe Analítico de Obligaciones Diferentes de Financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance Presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de Ingresos Detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de Cumplimiento de la Ley de Disciplina Financiera de las Entidades Federativas y los Municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance Presupuestario de Recursos Disponibles Negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o Creación del Gasto del Presupuesto de Egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el Año que Integra el Pasivo Circulante al Cierre del Ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos Excedentes Derivados de Ingresos de Libre Disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de Deuda Pública y Obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información Detallada de Contratación de Obligaciones a Corto Plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Comparativo del Estado de Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe Ejecutivo (Comparativos Situación Financiera y Ejercicio del Presupuesto de Egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de Ingresos Presupuestales por Rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la Situación Económica de las Finanzas Públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la Deuda Pública Variación respecto a la Deuda Pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 1 Erogaciones para la Ciencia y Tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 2 Derechos Humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 3 Transparencia y Rendición de Cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 4 Anexo Transversal Anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño ( Estrategia Transversal 5 Indicadores de Desempeño (Estratégicos y de Gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados (Avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, Proyectos, Obras o Acciones con Aportaciones de Recursos por parte del Gobierno del Estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los Programas de Reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y Remuneraciones Cubiertas a los Servidores Público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o Creación del Gasto del Presupuesto de Egresos (Etiquetado y No Etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por Prestación de Servicios Profesionales por Honorarios (Personas Físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2021/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },
    {
        "anio" : "2020",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de Variación en la Hacienda Pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de Cambios en la Situación Financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de Flujos de Efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico de la Deuda y Otros Pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de Pasivos Contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los Estados Financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los Ingresos Presupuestarios y Contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de Analitico de Ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación Económica de los Ingresos, de los Gastos y del Financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento Neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la Deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Postura Fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por Categoría Programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y Proyectos de Inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de Bienes Muebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de Bienes Inmuebles que Componen el Patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de Cuentas Bancarias Productivas Específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de Esquemas Bursátiles y de Coberturas Financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del Ejercicio y Destino de Gasto Federalizado y Reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, asignaciones, subsidios y subvenciones, y pensiones y jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (Del grupo Hacienda Pública/Patrimonio Contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de situación financiera detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de la deuda pública y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de obligaciones diferentes de financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación de servicios personales por categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de cumplimiento de la Ley de disciplina financiera de las entidades federativas y los municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance presupuestario de recursos disponibles negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el año que integra el pasivo circulante al cierre del ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos excedentes derivados de ingresos de libre disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de deuda pública y obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información detallada de contratación de obligaciones a corto plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Comparativo del estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe Ejecutivo (Comparativos Situación Financiera y Ejercicio del Presupuesto de Egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos presupuestales por rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la situación económica de las finanzas públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la deuda pública variación respecto a la deuda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (estrategia transversal 1 erogaciones para la ciencia y tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 2 Derechos Humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (Estrategia Transversal 3 Transparencia y Rendición de Cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 4 anexo transversal anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 5 indicadores de desempeño (estratégicos y de gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados (avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, proyectos, obras o acciones con aportaciones de recursos por parte del gobierno del estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los programas de reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y remuneraciones cubiertas a los servidores público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos (etiquetado y no etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por prestación de servicios profesionales por honorarios (personas físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2020/CPublica/AID.pdf"
                    },
                    
                ]
            },
        ]
    },
    {
        "anio" : "2019",
        "cpublicaLista" : [
            {
                "nombre" : "INFORMACIÓN CONTABLE",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de actividades",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EA.pdf"
                    },
                    {
                        "nombre" : "Estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ESF.pdf"
                    },
                    {
                        "nombre" : "Estado de variación en la hacienda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EVHP.pdf"
                    },
                    {
                        "nombre" : "Estado de cambios en la situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ECSF.pdf"
                    },
                    {
                        "nombre" : "Estado de flujos de efectivo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EFE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del activo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de la deuda y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EADOP.pdf"
                    },
                    {
                        "nombre" : "Informe de pasivos contingentes",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IPC.pdf"
                    },
                    {
                        "nombre" : "Notas a los estados financieros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/NEF.pdf"
                    },
                    {
                        "nombre" : "Conciliación entre los ingresos presupuestarios y contables",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CIPyCyEPyC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PRESUPUESTARIA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de analitico de ingresos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAI.pdf"
                    },
                    {
                        "nombre" : "Clasificación económica de los ingresos, de los gastos y del financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CEIGF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPECOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPECA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación económica (por tipo de gasto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPECE.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPECF.pdf"
                    },
                    {
                        "nombre" : "Endeudamiento neto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EN.pdf"
                    },
                    {
                        "nombre" : "Intereses de la deuda",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ID.pdf"
                    },
                    {
                        "nombre" : "Indicadores de postura fiscal",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IPF.pdf"
                    }, 
                ]
            },
            {
                "nombre" : "INFORMACIÓN PROGRAMÁTICA",
                "contenidocpublica" : [
                    {
                        "nombre" : "Gasto por categoría programática",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/GCP.pdf"
                    },
                    {
                        "nombre" : "Programas y proyectos de inversión",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/PyPI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IR.pdf"
                    },   
                ]
            },
            {
                "nombre" : "ANEXOS",
                "contenidocpublica" : [
                    {
                        "nombre" : "Relación de bienes muebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/RBM.pdf"
                    },
                    {
                        "nombre" : "Relación de bienes inmuebles que componen el patrimonio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/RBI.pdf"
                    },
                    {
                        "nombre" : "Relación de cuentas bancarias productivas específicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/RCBPE.pdf"
                    },
                    {
                        "nombre" : "Relación de esquemas bursátiles y de coberturas financieras",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/REByCF.pdf"
                    },
                    {
                        "nombre" : "Formato del ejercicio y destino de gasto federalizado y reintegros",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/FEyGFyR.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN PARA INTEGRAR Y CONSOLIDAR ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Transferencias, asignaciones, subsidios y subvenciones, y pensiones y jubilaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ITRSFP.pdf"
                    },
                    {
                        "nombre" : "Aportaciones (del grupo hacienda pública/patrimonio contribuido)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/APSFP.pdf"
                    },
                ]
            },
            {
                "nombre" : "LEY DE DICIPLINA FINANCIERA ",
                "contenidocpublica" : [
                    {
                        "nombre" : "Estado de situación financiera detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ESFD.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de la deuda pública y otros pasivos",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IADPyOP.pdf"
                    },
                    {
                        "nombre" : "Informe analítico de obligaciones diferentes de financiamiento",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IAODF.pdf"
                    },
                    {
                        "nombre" : "Balance presupuestario ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/BP.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos detallado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAID.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación por objeto del gasto (capítulo y concepto)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPEDCOG.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación administrativa",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPEDCA.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación funcional (finalidad y función)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPEDCF.pdf"
                    },
                    {
                        "nombre" : "Estado analítico del ejercicio del presupuesto de egresos detallado - LDF clasificación de servicios personales por categoría",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAEPEDCSPC.pdf"
                    },
                    {
                        "nombre" : "Guía de cumplimiento de la ley de disciplina financiera de las entidades federativas y los municipios",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/GC.pdf"
                    },
                ]
            },
            {
                "nombre" : "INFORMACIÓN ADICIÓNAL LDF",
                "contenidocpublica" : [
                    {
                        "nombre" : "Balance presupuestario de recursos disponibles negativo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/BPRDN.pdf"
                    },
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos durante el ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ACGDELPE.pdf"
                    },
                    {
                        "nombre" : "Devengados en el año que integra el pasivo circulante al cierre del ejercicio",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/DAIPCCE.pdf"
                    },
                    {
                        "nombre" : "Ingresos excedentes derivados de ingresos de libre disposición",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IEDILD.pdf"
                    },
                    {
                        "nombre" : "Contratación de deuda pública y obligaciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CDPyO.pdf"
                    },
                    {
                        "nombre" : "Información detallada de contratación de obligaciones a corto plazo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IDCOCP.pdf"
                    },     
                ]
            },
            {
                "nombre" : "INFORMACIÓN DEL PEEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Comparativo del estado de situación financiera",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CESF.pdf"
                    },
                    {
                        "nombre" : "Comparativo del estado analítico del ejercicio del presupuesto de egresos clasificación por objeto del gasto (capítulo y concepto) ",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CEAEPE.pdf"
                    },
                    {
                        "nombre" : "Informe ejecutivo (comparativos situación financiera y ejercicio del presupuesto de egresos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IEC.pdf"
                    },
                    {
                        "nombre" : "Estado analítico de ingresos presupuestales por rubro",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/EAIP.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la situación económica de las finanzas públicas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IEI.pdf"
                    },
                    {
                        "nombre" : "Informe sobre la deuda pública variación respecto a la deuda pública",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/VDP.pdf"
                    },
                    {
                        "nombre" : "Indicadores de Desempeño (Estrategia Transversal 1 Erogaciones para la Ciencia y Tecnología)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ECyTI.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 2 derechos humanos)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/DH.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 3 transparencia y rendición de cuentas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/TRC.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño (estrategia transversal 4 anexo transversal anticorrupción)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/TA.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño ( estrategia transversal 5 indicadores de desempeño (estratégicos y de gestión)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/IDEG.pdf"
                    },
                    {
                        "nombre" : "Indicadores de resultados (avances y resultados de la ejecución y evaluación de los programas presupuestarios)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/AyREyEPP.pdf"
                    },
                    {
                        "nombre" : "Programas, proyectos, obras o acciones con aportaciones de recursos por parte del gobierno del estado",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/PPOARGE.pdf"
                    },
                    {
                        "nombre" : "Avances en los programas de reducción del gasto",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/APRG.pdf"
                    },
                    {
                        "nombre" : "Tabuladores y remuneraciones cubiertas a los servidores público",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/TyRCSP.pdf"
                    },       
                ]
            },
            {
                "nombre" : "INFORMACIÓN DE LA LPCGEH",
                "contenidocpublica" : [
                    {
                        "nombre" : "Aumento o creación del gasto del presupuesto de egresos (etiquetado y no etiquetado)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/ACG.pdf"
                    },
                    {
                        "nombre" : "Contrataciones por prestación de servicios profesionales por honorarios (personas físicas)",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/CPSPHPF.pdf"
                    },
                    {
                        "nombre" : "Indicadores de desempeño",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/2019/CPublica/AID.pdf"
                    },
                    
                ]
            },

           
        ]
    },
]

